import {
  Component,
  OnInit,
  OnDestroy,
  Pipe,
  PipeTransform,
  TemplateRef,
} from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Router, RouterModule, ActivatedRoute } from "@angular/router";
import { map, filter, switchMap } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFireDatabase } from "@angular/fire/database";
import { Observable } from "rxjs";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SitedataService } from "../Services/sitedata.service";
import { LinksService } from "../Services/links.service";

import swal from "sweetalert2";

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;

  // Subscriptions
  authSub;

  projectName;
  searchTerm;
  linkSearchTerm;
  currentUser;
  currentNote;
  currentBookmarkType = 'all';
  notes = [];
  selectedLinkId;
  archivedNotes = [];
  notesToBind = [];
  capturedLinks = [];
  capturedLinksToBind = []; 
  activeNotes: boolean = true;
  focus = true;
  isLoading: boolean = false;
  constructor(
    public router: Router,
    public http: HttpClient,
    private sanitizer: DomSanitizer,
    public afAuth: AngularFireAuth,
    public db: AngularFireDatabase,
    private modalService: BsModalService,
    private siteData: SitedataService,
    private linksService: LinksService
  ) {}

  ngOnInit() {
    
    this.authSub = this.afAuth.user.subscribe((user) => {
      if (user) {
        this.isLoading = true;
        this.currentUser = user;
        this.getNotes(user.uid);
        this.getArchivedNotes(user.uid);
        this.isLoading = false;
      } else {
        this.router.navigate(["/signin"]);
      }
    });
  }
  
  getNotes(userId) {
    this.notes = [];
    this.notesToBind = [];
    this.db
      .list("/Notes/" + userId + "/active")
      .stateChanges(["child_added"])
      .subscribe((snapshot) => {
        let note = snapshot.payload.val();
        this.isLoading = false;
        if (this.activeNotes) {
          this.notesToBind.push(note);
        }
        this.notes.push(note);
        
        // this.selectedLinkId = this.notes[0].id;
        
        // this.notesToBind = this.activeNotes ? this.notes : this.archivedNotes;
        this.notesToBind.sort((a,b) => (a.lastUpdate > b.lastUpdate)? -1 : 1)
        
      });
    }


  getArchivedNotes(userId) {
    this.archivedNotes = [];
    this.notesToBind = [];
    this.db
      .list("/Notes/" + userId + "/archived")
      .stateChanges(["child_added"])
      .subscribe((snapshot) => {
        let note = snapshot.payload.val();
        
        this.archivedNotes.push(note);
        
        // this.notesToBind = this.activeNotes ? this.notes : this.archivedNotes;
        this.isLoading = false;
      });
    // this.db
    //   .list("/Notes/" + userId, (ref) =>
    //     ref.orderByChild("archived").equalTo(true)
    //   )
    //   .stateChanges(["child_added"])
    //   .subscribe((snapshot) => {
    //     let note = snapshot.payload.val();
    //     if ((<any>note).archived) {
    //       this.archivedNotes.push(note);
    //     }
    //     this.notesToBind = this.activeNotes ? this.notes : this.archivedNotes;
    //     this.isLoading = false;
    //   });
  }
  /**
   * Get the user id if authenticated user is found
   */
  checkAuthenticationStatus() {
    return new Promise((resolve, reject) => {
      this.authSub = this.afAuth.user.subscribe((user) => {
        if (user) {
          resolve(user);
        } else {
          reject(false);
        }
      });
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "full-modal" });
  }

  createProject() {
    var newNoteRef = this.db.database
      .ref("/Notes/" + this.currentUser.uid + "/active")
      .push();
    var newNoteId = newNoteRef.key;
    let notesData = {
      id: newNoteId,
      title: this.projectName,
      archived: false,
      lastUpdate: Date.now(),
    };

    newNoteRef.set(notesData);
    this.router.navigate(["/editor", newNoteId, this.activeNotes]);
  }

  filterNotes() {
    let notesToFilter = this.activeNotes ? this.notes : this.archivedNotes;
    this.performFilteration(notesToFilter);
  }


  // TODO:Refactor
  performFilteration(notesArray) {
    this.notesToBind = notesArray.filter((note) => {
      return (
        note.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
      );
    });
  }

  async archiveNote(note) {
    this.isLoading = true;
    var noteRef = this.db.database.ref(
      "/Notes/" + this.currentUser.uid + "/archived/" + note.id
    );

    note["archived"] = true;
    note ["lastUpdate"] = Date.now();
    // let notesData = {
    //   archived: true,
    //   lastUpdate: Date.now(),
    // };
    noteRef.update(note);
    this.deleteNote(note, true, false);
    let currentUser = await this.checkAuthenticationStatus();
    if (this.notesToBind.length == 1) {
      this.activeNotes = false;
    }
    this.getArchivedNotes((<any>currentUser).uid);
  }

  async unArchive(note) {
    var noteRef = this.db.database.ref(
      "/Notes/" + this.currentUser.uid + "/active/" + note.id
    );
    note["archived"] = false;
    note ["lastUpdate"] = Date.now();
    // let notesData = {
    //   archived: false,
    //   lastUpdate: Date.now(),
    // };
    noteRef.update(note);
    this.deleteNote(note, false, false);
    let currentUser = await this.checkAuthenticationStatus();
    if (this.archivedNotes.length == 1) {
      this.activeNotes = true;
    }
    this.getNotes((<any>currentUser).uid);
    
  }

  changeActiveNotesVisibility(visibility) {
    this.activeNotes = visibility;
    this.notesToBind = this.activeNotes ? this.notes : this.archivedNotes;
  }

  confirmDelete(note) {
    swal
      .fire({
        title: "Are you sure to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
        buttonsStyling: false,
        // confirmButtonClass: 'btn btn-danger',
        confirmButtonText: "Yes, delete it!",
        // cancelButtonClass: 'btn btn-secondary'
      })
      .then(async (result) => {
        if (result.value) {
          // Delete the note
          this.deleteNote(note, this.activeNotes, true)
        }
      });
  }

  async deleteNote(note, isActive, toDelete) {
    let noteStatus = isActive ? "active" :"archived";
    let currentUser = await this.checkAuthenticationStatus();
          var noteRef = this.db.database.ref(
            "/Notes/" + (<any>currentUser).uid + "/" + noteStatus + "/" + note.id
          );
          noteRef.set(null);
          if (isActive) {
            this.getNotes((<any>currentUser).uid);
          } else {
            this.getArchivedNotes((<any>currentUser).uid);
          }
          
          // Show confirmation
          if (toDelete) {
            swal.fire({
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success",
              // buttonsStyling: false,
              // confirmButtonClass: 'btn btn-primary'
            });
          }
  }

  closeSearch() {}

  
  closeLinkSearch() {
    
  }

  ngOnDestroy() {
    this.authSub = null;
  }
}
